<template>     
  <v-dialog v-model="dialog" persistent max-width="330">      
    <v-card>
      <v-card-title class="text-h5 text-center">
        Видалити дільницю?
      </v-card-title>
      <v-card-text class="text-center">Ви впевнені, що хочете видалити дільницю?</v-card-text>
      <v-card-actions>
        <v-btn
          color="deep-orange darken-1"
          text
          @click="closeDialog()"
        >
          Ні
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary lighten-1"
          text
          @click="sendForm"
        >
          Так
        </v-btn>
      </v-card-actions>
    </v-card>   
  </v-dialog>
</template>

<script>
    import axios from "axios"
    //import { mapGetters } from "vuex"
	export default {
    name: 'modal-confirm-delete-district',
		data: () => ({
            loading:false,
            dialog: false,
            district: {},
        }),
        methods: {
            show(district){
              this.district = district
              this.dialog = true;

            },
            closeDialog (){
              this.district = {}
                this.dialog = false
            },
            sendForm() {
            this.loading = true;
            axios({
                method: "delete",
                url: `/api/cabletv/user_district/${this.district?.id}/`,
            })
                .then(response => {
                if(response){
                  this.$store.dispatch('filters/fetchDistricts');
                    this.$router.app.$snack.show("Дільницю видалено")
                    this.closeDialog()
                }else{
                    this.$router.app.$snack.show("Помилка видалення дільниці", 'deep-orange')
                }
                })
                .catch(err => {
                //console.log(err);
                    this.$router.app.$sheet.show("Помилка!", err);
                })
                .finally(() => ( this.loading = false ))
                
            },
        }
    }
</script>